<template>
    <div class="filter-sidebar-header px-3">
        <div class="row pt-2">
            <div class="col-6">
                <p class="mb-0"><b>{{ $t('cat.filter') }}</b></p>
            </div>
            <div class="col-6 text-right">
                <span class="text-link" @click="resetFilter">{{$t('cat.filter.reset')}}</span>
            </div>
        </div>
        <!--
            <span class="filter-counter">
                {{ $tc('cat.filter.counter', counter, { count: counter }) }}
            </span>
        -->
    </div>
</template>

<script>
import { EventBus } from "../../event-bus";
export default {
    name: 'FilterSidebarHeader',
    data() {
        return {
            filterArray: []
        }
    },
    methods: {
        updateCounter(data) {
            if(data.name !== 'sort'){
                const index = this.filterArray.findIndex(name => name === data.name);

                if  (
                        (!Array.isArray(data.value) && data.value === '-1') || (Array.isArray(data.value) && data.value.length <= 0)
                        &&
                        index !== -1
                    ) {

                        this.filterArray.splice(index, 1);
                    } 
                
                if(
                    (!Array.isArray(data.value) && data.value !== '-1') || (Array.isArray(data.value) && data.value.length > 0)
                        &&
                        index === -1
                ) {
                    this.filterArray.push(data.name)
                }
            }
        },
        resetFilter(){
            this.filterArray = []
            EventBus.$emit('catalog-filters-reset', true);
        },
    },
    computed: {
        counter: function () {
            return this.filterArray.length
        }
    },
    mounted() {
        //EventBus.$on('catalog-update-filter-counter', this.updateCounter);
    }
}
</script>
